var render, staticRenderFns
import script from "./YearlyOrdersChart.vue?vue&type=script&lang=js&"
export * from "./YearlyOrdersChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79059516",
  null
  
)

export default component.exports